export enum SOFTWARE_PROGRESS_HEADERS {
  VERSION = 'Version',
  STARTED = 'Started',
  LAST_UPDATED = 'Last Updated',
  STATUS = 'Status',
}
